import ChevronLeft from 'svg/ChevronLeft';
import Share from 'svg/Share';
import Button from 'components/Button';

interface Props {
  onShare: () => void;
  /** Decided once by the screen; this only renders. */
  showBack?: boolean;
  onBack?: () => void;
}

/**
 * Figma's desktop "Page Header". The same two actions float on the cover photo on
 * mobile, so this bar only exists from `md` up and the cover hides its overlay
 * there — one rendering of each action at any width.
 */
export default function ProfilePageHeader({ onShare, showBack = true, onBack }: Props) {
  return (
    <div className="hidden border-b border-color-border-input-lightmode bg-color-bg-lightmode-primary dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary md:block">
      <div className="container mx-auto flex items-center justify-between py-ds-lg">
        {showBack ? (
          <Button
            variant="secondary"
            size="icon"
            aria-label="Go back"
            onClick={onBack}
            // "Round/No fill": the hit area is 40px but nothing is drawn behind it.
            className="h-10 w-10 border-transparent bg-transparent text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
        ) : (
          <span />
        )}

        <Button
          variant="primary"
          size="md"
          isInline
          iconLeft={<Share className="size-4" />}
          onClick={onShare}
        >
          Share
        </Button>
      </div>
    </div>
  );
}
